import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE; // ✅ unified variable

const OTPVerification = () => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();

    if (otp !== "123456") {
      alert("❌ Invalid OTP. Try 123456 (test only)");
      return;
    }

    const email = localStorage.getItem("userEmail");
    const phone = localStorage.getItem("userPhone");

    if (!email || !phone) {
      alert("❌ Missing email or phone in localStorage.");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/save-phone`, {
        email,
        phone,
      });

      navigate("/set-address");
    } catch (err) {
      console.error("❌ OTP Save Error:", err);
      alert("Failed to save phone. Try again.");
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">

        {/* Header */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800">
            Enter verification code
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Enter the 6-digit code sent to your phone
          </p>
        </div>

        <form onSubmit={handleVerify} className="space-y-4">
          <input
            type="text"
            placeholder="6-digit code"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <button
            type="submit"
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Verify & continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default OTPVerification;
